import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { useAppSelector } from 'src/utils/Hooks';

const Subtitle = ({ data }) => {
  const { app } = useAppSelector((state) => state);
  const [subTitle, linkTitle] = data.displayName.split(':');

  if (data.id !== undefined && /<a.*>(.+?)<\/a>/g.test(linkTitle)) {
    const linkTitleText = linkTitle.match(/<a.*>(.+?)<\/a>/)[1];

    return (
      <div className="chart-subtitle">
        <span>{subTitle}: </span>
        <NavLink to={`/${data.type}/${data.id}${app?.queryParams?.searchParams}${app?.queryParams?.additionalParams}`}>
          {linkTitleText}
        </NavLink>
      </div>
    );
  }

  return <div className="chart-subtitle">{subTitle}</div>;
};

Subtitle.propTypes = {
  data: PropTypes.object.isRequired
};

export default Subtitle;
